<template>
  <div>
    <el-table :data="list">
      <el-table-column prop="id" label="id" width="80"></el-table-column>
      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="coinType">
        <template slot-scope="scope">
          <span>{{ scope.row.coinType }}</span>
          <!-- <span>{{ scope.row.businessTime | moment }}</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="返佣率"></el-table-column>
      <el-table-column prop="feeAmount" label="总手续费"></el-table-column>
      <el-table-column prop="amount" label="奖励数量（总手续费x返佣率）"></el-table-column>
      <el-table-column prop="fromUser" label="fromUser"></el-table-column>
      <el-table-column prop="sourceUser" label="sourceUser"></el-table-column>
      <el-table-column prop="toUser" label="发放至账户"></el-table-column>
     
      <el-table-column prop="type" label="奖励等级">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type==1">一级奖励</el-tag>
          <el-tag v-if="scope.row.type==2">二级奖励</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发放状态">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status==0">未发放</el-tag>
          <el-tag type="success" v-if="scope.row.status==1">已发放</el-tag>
          <el-tag type="danger" v-if="scope.row.status==3">发放失败</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange($event)"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'commissionList',
  computed: {
    ...mapState('commission', ['totalCount', 'pagination','datas']),
    ...mapGetters('commission', ['list'])
  },
  components: {
    Pagination
  },

  methods: {
    ...mapActions('commission', ['remove']),
    ...mapMutations('commission', ['setDetail']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
   
    // handleCurrentSizeChange(pagination) {
    //   // this.$emit('refresh', pagination);
    // },
    viewDetail(item) {
      this.setDetail(item);
    },
    removeItem(row) {
      this.$confirm('确认要删除么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.remove(row.id).then(() => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.$emit('refresh', { page: 1 });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
